import React from 'react';
import { motion } from 'framer-motion';
import { gameStore } from '../game/store';
export function StartScreen() {
  const handleStart = () => {
    gameStore.setState({
      phase: 'cold_open'
    });
  };
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="absolute inset-0 z-50 bg-black flex flex-col items-center justify-center pointer-events-auto" data-id="element-145">
      {/* Background noise */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E\")"
    }} data-id="element-146" />

      {/* Vignette */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, transparent 20%, rgba(0,0,0,0.9) 90%)'
    }} data-id="element-147" />

      {/* Blood drip */}
      <motion.div initial={{
      height: 0
    }} animate={{
      height: 140
    }} transition={{
      delay: 0.3,
      duration: 1.5,
      ease: 'easeOut'
    }} className="w-0.5 bg-red-700 mb-6 relative z-10" data-id="element-148" />

      {/* Title */}
      <motion.h1 initial={{
      opacity: 0,
      y: 20,
      letterSpacing: '-0.05em'
    }} animate={{
      opacity: 1,
      y: 0,
      letterSpacing: '-0.03em'
    }} transition={{
      delay: 0.8,
      duration: 0.8
    }} className="relative z-10 text-7xl md:text-9xl font-black text-red-600 mb-2 glitch-active" style={{
      textShadow: '0 0 40px rgba(220,38,38,0.5), 0 0 80px rgba(220,38,38,0.3)'
    }} data-id="element-149">
        THE DESCENT
      </motion.h1>

      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 0.6
    }} transition={{
      delay: 1.3
    }} className="relative z-10 text-gray-500 uppercase tracking-[0.4em] text-xs md:text-sm mb-10" data-id="element-150">
        A Celestial Dungeon Authority Production
      </motion.p>

      {/* Divider */}
      <motion.div initial={{
      width: 0
    }} animate={{
      width: 320
    }} transition={{
      delay: 1.5,
      duration: 0.8
    }} className="h-px bg-red-900/50 mb-10 relative z-10" data-id="element-151" />

      {/* Controls */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.8
    }} className="relative z-10 text-center mb-12 max-w-lg px-4" data-id="element-152">
        <p className="text-gray-600 text-xs uppercase tracking-[0.3em] mb-4" data-id="element-153">
          Operational Parameters
        </p>
        <div className="flex flex-wrap gap-2 justify-center text-gray-400 text-xs uppercase tracking-wider" data-id="element-154">
          <span className="border border-gray-800 bg-black/60 px-3 py-1" data-id="element-155">
            [WASD] Move
          </span>
          <span className="border border-gray-800 bg-black/60 px-3 py-1" data-id="element-156">
            [SPACE] Kick
          </span>
          <span className="border border-gray-800 bg-black/60 px-3 py-1" data-id="element-157">
            [E] Stomp / Interact
          </span>
        </div>
        <p className="text-gray-600 text-xs mt-5 italic max-w-sm mx-auto" data-id="element-158">
          You will wake up. The building will collapse. You will descend.
          <br data-id="element-159" />
          Princess Donut will have thoughts.
        </p>
      </motion.div>

      {/* Enter button */}
      <motion.button initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 2.2
    }} whileHover={{
      scale: 1.05,
      boxShadow: '0 0 40px rgba(220,38,38,0.5)'
    }} whileTap={{
      scale: 0.95
    }} onClick={handleStart} className="relative z-10 px-12 py-5 bg-transparent text-red-400 font-black text-xl md:text-2xl uppercase tracking-[0.25em] border-2 border-red-500/60 hover:border-red-400 hover:text-red-300 hover:bg-red-950/30 transition-all cursor-pointer" style={{
      textShadow: '0 0 15px rgba(220,38,38,0.6)'
    }} data-id="element-160">
        Begin the Descent
      </motion.button>

      {/* Footer */}
      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 0.3
    }} transition={{
      delay: 2.8
    }} className="relative z-10 absolute bottom-8 text-gray-700 text-xs uppercase tracking-widest text-center max-w-md px-4" data-id="element-161">
        "You will not break me."
        <br data-id="element-162" />
        <span className="text-[10px] opacity-60" data-id="element-163">
          — every crawler, eventually
        </span>
      </motion.p>
    </motion.div>;
}